module.exports = __webpack_public_path__ + "img/austria-genitourinary-diseases-male.614d0962.png";